import { AxiosResponse } from 'axios';
import { supabase } from '@/lib/supabase';
import { asResponse } from '@/lib/supabase-helpers';

type GetByStatusAndPeriodResponseType = Record<string, number>;

type GetByStatusAndPeriodParamsType = {
  status: string;
  startDate: string;
  endDate: string;
};

const getByStatusAndPeriod = async (
  params: GetByStatusAndPeriodParamsType
): Promise<AxiosResponse<GetByStatusAndPeriodResponseType>> => {
  const { data, error } = await supabase.rpc('rpc_candidates_by_status_period', {
    p_status: params.status || '',
    p_start: params.startDate,
    p_end: params.endDate,
  });

  if (error) throw error;
  return asResponse<GetByStatusAndPeriodResponseType>(data || {});
};

const getSourceTotalByStatusAndPeriod = async (
  params: GetByStatusAndPeriodParamsType
): Promise<AxiosResponse<Record<string, number>>> => {
  const { data, error } = await supabase.rpc('rpc_source_total_by_status_period', {
    p_status: params.status || '',
    p_start: params.startDate,
    p_end: params.endDate,
  });

  if (error) throw error;
  return asResponse<Record<string, number>>(data || {});
};

export default {
  getByStatusAndPeriod,
  getSourceTotalByStatusAndPeriod,
};
